import { node as anthropometrics } from "src/modules/htx/forms/anthropometrics";
import { node as bloodGroup } from "src/modules/htx/forms/bloodGroup";
import { node as comorbidities } from "src/modules/htx/forms/comorbidities";
import { node as coordination } from "src/modules/htx/forms/coordination";
import { node as currentCardiologicalState } from "src/modules/htx/forms/current-cardiological-state";
import { node as labProcedures } from "src/modules/htx/forms/lab-procedures";
import { node as medicalHistory } from "src/modules/htx/forms/medical-history";
import { node as microbiologicalProcedures } from "src/modules/htx/forms/microbiological-procedures";
import { node as patientCondition } from "src/modules/htx/forms/patientCondition";
import { node as patientConditionReport } from "src/modules/htx/forms/patientConditionReport";
import { node as patientStatementOfConsent } from "src/modules/htx/forms/patientStatementOfConsent";
import { node as risks } from "src/modules/htx/forms/risks";
import { node as screeningProcedures } from "src/modules/htx/forms/screening-procedures";
import { node as sensitization } from "src/modules/htx/forms/sensitization";
import { node as vaccinationStatus } from "src/modules/htx/forms/vaccinationStatus";
import { LeafNode, ParentNode } from "src/modules/shared/form-explorer";

export const forms: (ParentNode | LeafNode)[] = [
	anthropometrics,
	bloodGroup,
	medicalHistory,
	currentCardiologicalState,
	comorbidities,
	screeningProcedures,
	labProcedures,
	sensitization,
	microbiologicalProcedures,
	vaccinationStatus,
	risks,
	patientCondition,
	patientConditionReport,
	coordination,
	patientStatementOfConsent
];
